/* Copyright 2012 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  getGlobalEventBus,
  isMobile,
  NullL10n
} from './ui_utils';

/**
 * Creates a "search bar" given a set of DOM elements that act as controls
 * for searching or for setting search preferences in the UI. This object
 * also sets up the appropriate events for the controls. Actual searching
 * is done by PDFFindController.
 */

let totalThicknessWidth = function (b) {
  if (!b && !bookConfig.showThicknessOnMobile) return 0;
  totalWidth = oneSideTotalThicknessWidth();
  b && (totalWidth *= 2);
  return totalWidth
},
oneSideTotalThicknessWidth = function () {
  var b = getMaxThicknessWidth(),
      c = Math.min(bookConfig.totalPageCount, 100),
      c = $.easing.easeOutQuad(null, c, 0, b, 100),
      c = Math.floor(c),
      d = 1,
      d = $.easing.swing(null, Math.max(c - 8, 0), 1, d - 1, b - 8);
  return c = Math.floor(c * d);
},

getMaxThicknessWidth = function (widthType) {
  switch (widthType) {
      case 'none':
          return 0;
      case 'thinner':
          return 5;
      case 'thin':
          return 15;
      case 'thicker':
          return 40;
  }
  return 20;
};

const thickessPerBar = 1, originColor = { r: 255, g: 255, b: 255, };

function drawThickeness(context, width, height, f, g) {
    let totalheight = height;
    let h = 0,
        d = thickessPerBar / 8 / 1.5;
    let k;
    k = Math.max(5 * width / 12, 10);
    k = Math.min(k, 32);
    k = k % 2 === 0 ? k : k + 1;
    let l = 0,
        m = 0;
    Math.max(k, 4);
    for (Math.min(k, 12); m < width;) {
        k = getColorAtIdx(m, width);
        h = d * m - Math.sin(Math.PI / 2 / 4 * m / width) * d * m / 2;
        h = d * m;
        l = totalheight - 2 * h;
        for (k = k.toString(16); k.length < 6;) {
          k = '0' + k;
        }
        context.fillStyle = '#' + k;
        context.fillRect(f + g * m, h, 1, l);
        context.fill();
        m++;
    }
}
const COLOR_0 = 243,
    COLOR_1_1 = 209,
    COLOR_1_2 = 231,
    COLOR_2_1 = 209,
    COLOR_2_2 = 213;

function getColorAtIdx(b, c) {
    let d = 0,
        f = d = 0;
    d = Math.max(3, c / 6 + c / 4);
    d = Math.min(11, d);
    d = d % 2 === 0 ? d - 1 : d;
    let g = originColor.r / 255,
        h = originColor.g / 255,
        k = originColor.b / 255;
    b === 0 ? d = COLOR_0 : b < d ? d = b % 2 === 0 ? COLOR_1_2 : COLOR_1_1 : (d = (b - d) / 2, f = 4 < d / 2 ? 24 : 6 * Math.floor(d / 2), d = 0 == d % 2 ? COLOR_2_1 - f : COLOR_2_2 - f);
    return d * k | d * h << 8 | d * g << 16;
}

class DivHint {
  constructor(page, left, top, f) {
      this.instance = $('<div class="hint"></div>');
      this.setText(page);
      if (!f) {
        f = $('body');
      }

      f.append(this.instance);
      this.instance.css({
          display: 'none',
          opacity: 0,
      });

      this.moveto(left, top);
      this.animation = !1;
      this.className = 'hint';
  }

  setAnimate(b) {
      this.animation = b;
      !0 == b && this.instance.css({
          '-moz-transition': 'all 0.2s ease-in-out',
          '-webkit-transition': 'all 0.2s ease-in-out',
          '-o-transition': 'all 0.2s ease-in-out',
          '-ms-transition': 'all 0.2s ease-in-out',
          'transition': 'all 0.2s ease-in-out'
      })
  }

  setStyle(b) {
      this.instance.removeClass(this.className);
      this.instance.addClass(b);
      this.className = b;
  }

  setText(b) {
      this.instance.html(b);
  }

  moveto(b, c) {
      this.instance.css({
          left: b,
          top: c,
      });
  }

  show() {
      this.instance.css({
          display: 'block',
          opacity: 1,
      });
  }

  hide() {
      !0 == this.animation ? this.instance.css({
              display: 'none',
              opacity: 0
          }) :
          this.instance.css({
              display: 'none',
              opacity: 1
          })
  }

  destroy() {
      this.hide();
      this.instance.empty();
      this.instance.remove();
  }

  width() {
      return this.instance.width() + 3 * this.padding();
  }

  height() {
      return this.instance.height() + 3 * this.padding();
  }

  padding() {
    let b = this.instance.css('padding');
    return void b === 0 || b === null || b === '' ? 0 : iPadding = parseInt(b.replace('px', ''));
  }

  addClass(b) {
      this.instance.addClass(b);
  }
}

class PDFDepth {
  constructor(options, eventBus = getGlobalEventBus(), l10n = NullL10n) {
    this.container = options.container || null;
    this.book = options.book || null;
    this.leftDepth = options.leftDepth || null;
    this.rightDepth = options.rightDepth || null;
    this.eventBus = eventBus;
    this.l10n = l10n;
    this.totalPageCount = 0;
    this.endIndex = this.startIndex = this.pageCount = 0;
    this.scale = 1;
    this.totalWidth = getMaxThicknessWidth('thin');
    this.width = this.totalWidth;
    this.height = 0;
    this.create();
    this.eventBus.on('pagesloaded', this.setPageCount.bind(this));
    this.eventBus.on('pagechanging', this.pageChanging.bind(this));
    this.eventBus.on('resize', this.onResize.bind(this));
    this.Container = $('#viewerContainer');
  }

  setPageCount(evt) {
    this.totalPageCount = evt.pagesCount;
    this.height = parseInt($(this.container).css('height')) - 4;
    if(this.book.turn('is')){
      let size = this.book.turn('size');
      this.height = size.height;
    }
    
    this.setDepth(1);
    if (!isMobile()) {
      this.leftDepth.css('display', 'block');
      this.rightDepth.css('display', 'block');
    }else{
      this.leftDepth.css('display', 'none');
      this.rightDepth.css('display', 'none');      
    }
  }

  pageChanging(evt) {
    this.pageCount = evt.pageNumber;
    this.startIndex = this.pageCount;
    this.setDepth(this.pageCount);
  }

  setDepth(pageCount) {
    let leftWidth = this.getThicknessWidth(pageCount);
    let rightWidth = this.totalWidth - leftWidth;

    this.setLeftDepth(leftWidth);
    this.setRightDepth(rightWidth);
  }

  setLeftDepth(width) {
    this.leftDepth.css('width', width);
    this.leftCanvas.attr('height', this.height + 'px');
    this.leftCanvas.attr('width', width + 'px');
    this.leftcontext.clearRect(0, 0, width, this.height);
    drawThickeness(this.leftcontext, width, this.height, width, -1);
  }

  setRightDepth(width) {
    if(width < 2)
      this.rightDepth.css('display', 'none');
    else{
      if (!isMobile()) {
        this.rightDepth.css('display', 'block');
      }else{
        this.rightDepth.css('display', 'none');
      }
    }

    this.rightDepth.css('width', width);
    this.rightCanvas.attr('height', this.height + 'px');
    this.rightCanvas.attr('width', width + 'px');
    this.rightcontext.clearRect(0, 0, width, this.height);
    drawThickeness(this.rightcontext, width, this.height, 0, 1);
  }

  create() {
    this.init();
    this.initShadow();
    this.initEvent();
  }

  init() {
    this.thicknessWidth = getMaxThicknessWidth('thick');
    this.leftCanvas = $('<canvas style="top:0;left:0;" id="leftCanvas">');
    this.rightCanvas = $('<canvas style="top:0;left:0;" id="rightCanvas">');
    this.leftDepth.append(this.leftCanvas);
    this.rightDepth.append(this.rightCanvas);
    this.leftcontext = this.leftCanvas[0].getContext('2d');
    this.rightcontext = this.rightCanvas[0].getContext('2d');
  }

  initShadow() {
    this.leftshadow || $.browser.msie && 11 > $.browser.version || (this.leftshadow = $('<div class="shadow"></div>'), this.leftDepth.append(this.leftshadow));
    this.rightshadow || $.browser.msie && 11 > $.browser.version || (this.rightshadow = $('<div class="shadow"></div>'), this.rightDepth.append(this.rightshadow)) 
  }

  refresh(b, c) {
    this.startIndex = b;
    this.endIndex = c;
    this.pageCount = this.endIndex - this.startIndex;
    this.width = this.getThicknessWidth(Math.abs(this.pageCount));
    this.thickness.css({
        width: this.width +
            'px'
    });
    this.thicknessCanvas.attr('width', this.width + 'px');
    this.context.clearRect(0, 0, this.thicknessWidth, this.height);
    this.isLeft ? (this.thickness.css({
        left: -this.width + 'px'
    }), drawThickeness(this.context, this.width, this.height, this.width, -1)) : drawThickeness(this.context, this.width, this.height, 0, 1);
  }

  onResize(b, c) {
    this.resizeThickness(b, c);
    this.resizeShadow(b, c);
  }

  show() {
    this.thickness.show();
  }

  hide() {
    this.thickness.hide();
  }

  hideCanvas() {
    this.leftCanvas.hide();
    this.rightCanvas.hide();
  }

  showCanvas() {
    this.leftCanvas.show();
    this.rightCanvas.show();
  }

  resizeShadow(b, c) {}

  resizeThickness(b, c) {
    this.height = parseInt($(this.container).css('height')) - 4;
    if(this.book.turn('is')){
      let size = this.book.turn('size');
      this.height = size.height;
    }

    this.leftCanvas.attr('height', this.height + 'px');
    this.rightCanvas.attr('height', this.height + 'px');

    this.setDepth(this.pageCount);

  }

  resetTotalWidth(b, c) {
    this.totalWidth = oneSideTotalThicknessWidth();
  }

  getPageIndexByPosition(evt, isLeft) {
    let b = this.getDistance(evt, isLeft);
    if (b < 0) {
      b = 0;
    }

    let startIndex = 0, endIndex = 0, width = this.totalWidth;
    if (isLeft) {
      startIndex = 0;
      endIndex = this.pageCount;
      width = parseInt(this.leftDepth.css('width'));
    } else {
      startIndex = this.pageCount;
      endIndex = this.totalPageCount - this.pageCount;
      width = parseInt(this.rightDepth.css('width'));
    }

    return startIndex + parseInt(endIndex * b / width);
  }

  getDistance(evt, isLeft) {
    let b = evt.pageX;
    let c = 0;

    if (isLeft) {
      c = this.leftDepth.offset().left;
    } else {
      c = this.rightDepth.offset().left;
    }

    return b - c;
  }

  getThicknessWidth(b) {
    return this.width = Math.floor(this.totalWidth * b / this.totalPageCount);
  }

  getWidth() {
    return this.width;
  }

  getHeight() {
    return this.height;
  }

  gotoPageFun(page) {
    $('#viewer').turn('is') && $('#viewer').turn('page', page);
    this.eventBus.dispatch('pagenumberchanged', {
      source: self,
      value: page,
    });
  }

  initEvent() {
    this.leftDepth.bind('mouseup touchstart',
      function (b) {
        b.stopPropagation();
      }
    );

    this.rightDepth.bind('mouseup touchstart',
      function (b) {
        b.stopPropagation();
      }
    );

    this.leftDepth.click(function (evt) {
      if (this.totalPageCount !== 0) {
        let page = this.getPageIndexByPosition(evt, true);
        if (page > 0) {
          this.gotoPageFun(page);
        }
      }
    }.bind(this));

    this.rightDepth.click(function (evt) {
      if (this.totalPageCount !== 0) {
        let page = this.getPageIndexByPosition(evt, false);
        if (page > 0) {
          this.gotoPageFun(page);
        }
      }
    }.bind(this));

    let that = this;
    if (!isMobile()) {
      this.rightDepth.mousemove(function (evt) {
        if (that.totalPageCount !== 0) {
            let page = that.getPageIndexByPosition(evt, false);
            if (!page || page <= 0) {
              if (that.hint) {
                that.hint.hide();
              }
            } else {
              let left = evt.pageX - that.Container.offset().left,
              top = evt.pageY - that.Container.offset().top - 30;

              if (!that.hint) {
                that.hint = new DivHint(page, left, top, that.rightDepth);
              } else {
                that.hint.setText(page);
                that.hint.show(left, top);
                that.hint.moveto(left, top);
              }
            }
        }
      });

      this.rightDepth.mouseleave(function () {
          if (that.hint !== null) {
            that.hint.hide();
          }
      });

      this.leftDepth.mousemove(function (evt) {
        if (that.totalPageCount !== 0) {
            let page = that.getPageIndexByPosition(evt, true);
            if (!page || page <= 0) {
              if (that.hint) {
                that.hint.hide();
              }
            } else {
              let left = evt.pageX - that.Container.offset().left,
              top = evt.pageY - that.Container.offset().top - 30;

              if (!that.hint) {
                that.hint = new DivHint(page, left, top, that.leftDepth);
              } else {
                that.hint.setText(page);
                that.hint.show(left, top);
                that.hint.moveto(left, top);
              }
            }
        }
      });

      this.leftDepth.mouseleave(function () {
          if (that.hint !== null) {
            that.hint.hide();
          }
      });
    }
  }

  doSetMovingScale(b, c, d, f, g) {
    if (!((isPhone() || isPad()) && !bookConfig.HardPageEnable || !this.totalWidth || 0 >= this.totalWidth || (g = g ? 0 : Math.min(5 / this.totalWidth, 1), 1 == g || (1 != b && 1 != c || bookConfig.isTheBookOpen && BookInfo.isDoublePage()) && b != totalPageCount && c != totalPageCount))) {
        var h = 1,
            k = 1;
        (1 != b || bookConfig.isTheBookOpen && BookInfo.isDoublePage()) && b != totalPageCount || (h = g);
        (1 != c || bookConfig.isTheBookOpen && BookInfo.isDoublePage()) &&
        c != totalPageCount || (k = g);
        b = $.easing.easeInOutSine(null, d, h, k - h, f);
        this.setScale(b)
    }
  }
    
  setScale(b) {
    this.thickness.css({
        transform: "scaleX(" + b + ") scaleZ(1)",
        "-webkit-transform": "scaleX(" + b + ") scaleZ(1)",
        "-moz-transform": "scaleX(" + b + ") scaleZ(1)",
        "-ms-transform": "scaleX(" + b + ") scaleZ(1)",
        "-o-transform": "scaleX(" + b + ") scaleZ(1)"
    });
    this.scale = b;
  }
}

export {
  PDFDepth,
};
